import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@modules/auth/hooks';
import { REFERRALS_QUERY_KEY } from '../constants';
import { fetchReferrals } from '@modules/genetic-counseling/services';
import { ReferralsResponse, UseQueryReferralsParams } from '../types';

const useQueryReferrals = <TData = unknown, TError = unknown>(
  params: UseQueryReferralsParams,
  options?: Omit<
    UseQueryOptions<
      ReferralsResponse<TData> | undefined,
      TError,
      ReferralsResponse<TData> | undefined,
      Array<string | UseQueryReferralsParams>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<ReferralsResponse<TData> | undefined> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([REFERRALS_QUERY_KEY, params], async () => await fetchReferrals<TData>(params), {
    ...options,
    retry: false, // retry is made by BE for this endpoint.
    enabled: isAuthenticated === true && enabledOption,
  });
};

export default useQueryReferrals;
